import { ResourcesConfig } from 'aws-amplify';

function parseList(strList: string): string[] {
  return strList ? strList.split(',').map((item) => item.trim()) : [];
}

export const amplifyConfig: ResourcesConfig = {
  Auth: {
    Cognito: {
      userPoolClientId: import.meta.env.VITE_AWS_USER_POOLS_WEB_CLIENT_ID!,
      userPoolId: import.meta.env.VITE_AWS_USER_POOLS_ID!,
      loginWith: {
        oauth: {
          domain: import.meta.env.VITE_OAUTH_DOMAIN!,
          scopes: ['email', 'openid', 'profile'],
          redirectSignIn: parseList(import.meta.env.VITE_OAUTH_REDIRECT_SIGNIN),
          redirectSignOut: parseList(import.meta.env.VITE_OAUTH_REDIRECT_SIGNOUT),
          responseType: 'code'
        }
      }
    }
  }
};

export const supportLinks = {
  student: import.meta.env.VITE_SUPPORT_LINK_STUDENT as string,
  staff: import.meta.env.VITE_SUPPORT_LINK_STAFF as string,
};

export const rumSettings = {
  enabled: import.meta.env.VITE_RUM_ENABLED && import.meta.env.VITE_RUM_ENABLED === 'true',
  config: {
    applicationId: import.meta.env.VITE_RUM_APPLICATION_ID!,
    identityId: import.meta.env.VITE_RUM_IDENTITY_POOL_ID!,
    unauthenticatedRoleArn: import.meta.env.VITE_RUM_UNAUTHENTICATED_ROLE_ARN!,
    sessionSampleRate: Number(import.meta.env.VITE_RUM_SAMPLE_RATE!),
    region: import.meta.env.VITE_RUM_REGION!
  }
};
